var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendMoneyConsumer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 254,
    height: 54,
    viewBox: "0 0 254 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7116",
    "data-name": "Group 7116",
    transform: "translate(-125 -1190)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2030",
    "data-name": "Rectangle 2030",
    transform: "translate(125 1190)",
    fill: "#6faa00",
    stroke: "rgba(33,33,33,0.1)",
    strokeWidth: 1,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 254,
    height: 54,
    rx: 27,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 253,
    height: 53,
    rx: 26.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Send_Money_Safely",
    "data-name": "Send Money Safely",
    transform: "translate(191 1225)",
    fill: "#212121",
    fontSize: 20,
    fontFamily: "JioType-Medium, JioType",
    fontWeight: 500,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Send Money Safely")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(141 1196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_24",
    "data-name": "Polygon 24",
    d: "M8.464,1.844a2,2,0,0,1,3.073,0l5.73,6.876A2,2,0,0,1,15.73,12H4.27A2,2,0,0,1,2.734,8.72Z",
    transform: "translate(148.248 1221.002) rotate(-60)",
    fill: "#369b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7164",
    "data-name": "Path 7164",
    d: "M5.685,1.521a1.1,1.1,0,0,1,1.7,0l3.161,3.793a1.1,1.1,0,0,1-.848,1.81H3.372a1.1,1.1,0,0,1-.848-1.81Z",
    transform: "translate(159.947 1223.753) rotate(-60)",
    fill: "#369b00",
    opacity: 0.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMoneyConsumer);
export default __webpack_public_path__ + "static/media/send-money-consumer.96b2c7ead2ed73ee8359d54426c3d499.svg";
export { ForwardRef as ReactComponent };